import React from 'react';
import { Helmet } from "react-helmet";
import Sidenavigation from '../layout/Sidenavigation'
import Topnavigation from '../layout/Topnavigation';
import Content from '../sections/Helpdesk-Vendors-Registration/Content';

function Defaultregister() {
    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme">
            {/* title  */}
            <Helmet>
                <title>Vendor Registration</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end  */}

            <main className="body-content">

                {/* Topnavigation start  */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content />
                {/* page content end  */}

            </main>

        </div>
    );
}

export default Defaultregister;